import { defineMessages } from 'react-intl'

export default defineMessages({
  newOrderTitle: {
    id: 'containers.CustomerOrderUpsertPage.containers.TemplatePage.newOrderTitle',
    defaultMessage: 'Place a new order',
  },
  newOrderBody: {
    id: 'containers.CustomerOrderUpsertPage.containers.TemplatePage.newOrderBody',
    defaultMessage: 'Choose which kind of order you want to place, and fill out the form to place a new orders right away.',
  },
})